import { Flex, Text } from '@sendoutcards/quantum-design-ui'
import React from 'react'
import { useSelector } from 'src/hooks'
import { CreditCardLogo } from 'src/payments/components'
import { CreditCardBrand } from 'src/payments/components/CardLogo/CreditCardLogo'
import CreditCard from 'src/payments/components/CreditCard/CreditCard'

type MethodCardProps = {
  title: string
  last4: string
  type?: CreditCardBrand
  name: string
  exp: string
}

const MethodLogoText: React.FC<{ last4: string; type: CreditCardBrand }> = ({
  last4,
  type,
}) => {
  const isMobile = useSelector(state => state.window.isMobile)

  return (
    <Flex alignItems="center" justifyContent="center" columnGap="x1">
      <CreditCardLogo brand={type ?? 'Visa'} />
      <Text
        content={`Ending In ${last4}`}
        type={isMobile ? 'footnote' : 'caption'}
        weight="bold"
        color="primaryHeading"
      />
    </Flex>
  )
}
export const MethodCard: React.FC<MethodCardProps> = ({
  title,
  last4,
  type,
  name,
  exp,
}) => {
  const isMobile = useSelector(state => state.window.isMobile)

  return (
    <Flex
      position="relative"
      borderRadius="21px"
      backgroundColor="foreground"
      inset="x2"
      width="100%"
      justifyContent="space-between"
      alignItems="center"
      columnGap="x1"
    >
      <MethodLogoText last4={last4} type={type ?? 'Visa'} />
      <Flex
        position={isMobile ? 'relative' : 'absolute'}
        right={isMobile ? undefined : '16px'}
        top={isMobile ? undefined : '-16px'}
        width={isMobile ? '80px' : '125px'}
      >
        <CreditCard
          cardType={type ?? 'Visa'}
          last4={last4}
          name={name}
          exp={exp}
          width={'125px'}
          height="auto"
        />
      </Flex>
    </Flex>
  )
}
